import { render, staticRenderFns } from "./Servicemapping.html?vue&type=template&id=299d08fa&scoped=true&external"
import script from "./Servicemapping.js?vue&type=script&lang=js&external"
export * from "./Servicemapping.js?vue&type=script&lang=js&external"
import style0 from "./Servicemapping.scss?vue&type=style&index=0&id=299d08fa&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299d08fa",
  null
  
)

export default component.exports